export const providerCallLogOutcomes = [
  'Provider/Fax Number Confirmed',
  'Left Voicemail/Live Message',
  'Unsuccessful Call',
  'Records Pending',
  'Provider not at Practice',
  'Patient not at practice',
  'Pharmacy Call',
  'Practice Requires Release',
  'CE Has Consult Note/CE Review',
];
